export default __webpack_public_path__ + "static/media/Kanthamma@2x.1154cb52.png";